const { IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, withStyles } = window.Material;
const { Delete, Folder, Description } = window.MaterialIcons;
import { DisplayItem } from '../types/types';
import { PathPickerType } from '../types/enums';
import { fetchItems } from '../actions';

const styles = {};

interface ItemListProps {
  selected: string[];
  onDeleteBtnClick: Function;
  isMandatory: boolean;
  disabled: boolean;
  classes: any;
  hidden: string[];
}

interface ItemListState {
  selectedItems: DisplayItem[];
}

class DisplayList extends window.React.PureComponent<ItemListProps, ItemListState> {
  constructor(props: ItemListProps) {
    super(props);
    this.state = {
      selectedItems: [],
    };
  }

  componentDidMount() {
    const { selected } = this.props;

    this.setSelectedItems(selected || []);
  }

  componentDidUpdate(prevProps: ItemListProps) {
    const { selected } = this.props;

    if (prevProps.selected !== selected) {
      this.setSelectedItems(selected || []);
    }
  }

  setSelectedItems = async (nodeRefs: string[]) => {
    const { hidden } = this.props;

    const selectedItems: DisplayItem[] = await fetchItems(nodeRefs, hidden);

    this.setState({
      selectedItems,
    });
  };

  forwardToItem = (item: DisplayItem) => {
    const { type, nodeRef, path, name } = item;

    if (type === PathPickerType.FILE) {
      window.location.href = `${window.appContext}/page/document-details?nodeRef=${nodeRef}`;
    } else if (path) {
      window.location.href = `${window.appContext}/page/site/${path
        .map(item2 => (item2.name === 'documentLibrary' ? 'documentlibrary#/' : item2.name))
        .join('/')}/${name === 'documentLibrary' ? 'documentlibrary#' : name}/?page=1`;
    }
  };

  onDelete = (nodeRef: string) => {
    const { onDeleteBtnClick } = this.props;

    onDeleteBtnClick(nodeRef);
  };

  render() {
    const { isMandatory, disabled } = this.props;

    const { selectedItems } = this.state;

    return (
      <window.React.Fragment>
        <List>
          {selectedItems?.map((item: DisplayItem, _index: number, array: DisplayItem[]) => {
            //Show delete button if the component is not mandatory or is mandatory and more than one item left and it
            //is not disabled.
            const showDeleteBtn = !(isMandatory && array.length === 1) && !disabled && item.deletable;

            const { type, nodeRef, name, path } = item;

            return (
              <ListItem key={nodeRef} onClick={() => this.forwardToItem(item)} className="PathPicker-Field">
                <ListItemIcon>{type === PathPickerType.FOLDER ? <Folder /> : <Description />}</ListItemIcon>
                <ListItemText
                  style={{
                    paddingRight: showDeleteBtn ? '60px' : 0,
                    wordBreak: 'break-all',
                  }}
                  primary={name}
                  secondary={
                    path
                      ? path.every(pathEl => pathEl.name === '')
                        ? ''
                        : path.map(pathEl => pathEl.name || pathEl).join('/')
                      : null
                  }
                />
                {showDeleteBtn && (
                  <ListItemSecondaryAction>
                    <IconButton onClick={() => this.onDelete(nodeRef)} edge="end" aria-label="delete">
                      <Delete />
                    </IconButton>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
            );
          })}
        </List>
      </window.React.Fragment>
    );
  }
}

export default withStyles(styles)(DisplayList);
